"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "scena": {
    "54849ba6": [{
      "hkey": "cdcf6bdf",
      "slug": "scena",
      "name": "Scena",
      "primary": true,
      "skipSearch": false
    }],
    "montescena": [{
      "hkey": "cdcf6bdf",
      "slug": "scena",
      "name": "Scena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50cd0e0f": [{
      "hkey": "cdcf6bdf",
      "slug": "scena",
      "name": "Scena",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "cdcf6bdf",
      "slug": "scena",
      "name": "Scena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;